import { LinkBackTo } from "../pages/styled"
export const BackToArchPanel = () => {
  return (
    <div className="mt-1 mb-3">
      <LinkBackTo to="/archiwum">
        <button className="btn btn-outline-light btn-sm ps-3 pe-3">
          Powrót do panelu archiwum
        </button>
      </LinkBackTo>
    </div>
  );
}
